// Check both environment variable and localStorage for debug mode
const DEBUG = process.env.REACT_APP_DEBUG === 'true' ||
              (typeof window !== 'undefined' && localStorage.getItem('debug') === 'true');

export const debugLog = (...args) => {
  if (DEBUG) {
    console.log(...args);
  }
};

export const debugError = (...args) => {
  if (DEBUG) {
    console.error(...args);
  }
};

export const debugWarn = (...args) => {
  if (DEBUG) {
    console.warn(...args);
  }
};

// Enable debug mode from console: window.enableDebug()
if (typeof window !== 'undefined') {
  window.enableDebug = () => {
    localStorage.setItem('debug', 'true');
    console.log('🐛 Debug mode enabled. Reload the page to see debug logs.');
  };

  window.disableDebug = () => {
    localStorage.removeItem('debug');
    console.log('Debug mode disabled. Reload the page.');
  };
}